
<template>
  <div>
    <h1>Sorry</h1>
        404 - Page not found!
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
